// Module
var code = "<span data-bind=\"text: RecipientName\" class=\"mail-recipient\"> </span>";
// Exports
export default code;